import { render, staticRenderFns } from "./ModalCadastroClientes.vue?vue&type=template&id=3bc3b814&"
import script from "./ModalCadastroClientes.vue?vue&type=script&lang=js&"
export * from "./ModalCadastroClientes.vue?vue&type=script&lang=js&"
import style0 from "./ModalCadastroClientes.vue?vue&type=style&index=0&lang=sass&module=true&"
import style1 from "./ModalCadastroClientes.vue?vue&type=style&index=1&lang=sass&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./ModalCadastroClientes.vue?vue&type=style&index=0&lang=sass&module=true&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./ModalCadastroClientes.vue?vue&type=style&index=0&lang=sass&module=true&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js").rerender("3bc3b814")
            }
          }
        })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bc3b814')) {
      api.createRecord('3bc3b814', component.options)
    } else {
      api.reload('3bc3b814', component.options)
    }
    module.hot.accept("./ModalCadastroClientes.vue?vue&type=template&id=3bc3b814&", function () {
      api.rerender('3bc3b814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/ModalCadastroClientes.vue"
export default component.exports